import { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AppContext } from "@/App";
import api from "@/lib/api";
import { CheckCircle2, Loader2, Clock } from "lucide-react";

export default function PaymentSuccess() {
  const { t } = useContext(AppContext);
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("pending");
      return;
    }
    const poll = async () => {
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch { /* keep polling */ }
      attempts.current += 1;
      if (attempts.current < 15) {
        setTimeout(poll, 2000);
      } else {
        setStatus("pending");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E] px-4">
      <div className="card-surface max-w-md p-10 text-center" data-testid="payment-success-page">
        {status === "checking" && (
          <>
            <Loader2 className="mx-auto mb-4 h-12 w-12 animate-spin text-[#D4AF37]" />
            <p className="text-neutral-300">{t.payment.checking}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto mb-4 h-12 w-12 text-emerald-400" />
            <h1 className="font-display text-3xl font-semibold text-white">{t.payment.successTitle}</h1>
            <p className="mt-3 text-sm text-neutral-400">{t.payment.successSub}</p>
          </>
        )}
        {status === "pending" && (
          <>
            <Clock className="mx-auto mb-4 h-12 w-12 text-amber-400" />
            <p className="text-neutral-300">{t.payment.stillPending}</p>
          </>
        )}
        <div className="mt-8 flex flex-col gap-2">
          <Link to="/account" data-testid="success-account-link" className="btn-gold">{t.payment.viewAccount}</Link>
          <Link to="/" data-testid="success-home-link" className="btn-outline-gold">{t.payment.backHome}</Link>
        </div>
      </div>
    </div>
  );
}
